import React, { useState, useEffect, Fragment } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import QRCode from "react-qr-code";
import { Event } from "../../../Tracking/Tracking";
import download from "downloadjs";
import * as htmlToImage from "html-to-image";

const AccountMember = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { user } = useSelector((state) => state.auth);
  const [state, setState] = useState(null);

  useEffect(() => {
    if (user) {
      if (pathname.includes(user?.user?.role)) {
        setState(user);
      } else {
        history.replace(`/dashboard/${user?.user?.role}/account`);
      }
    }
  }, [user, pathname]);
  const onImageDownload = () => {
    Event("Download", "QR", "Eksplode code qr");
    htmlToImage
      .toPng(document.getElementById("QR"))
      .then(function(dataUrl) {
        download(dataUrl, "QR.png");
      })
      .catch(function(error) {
        console.error("oops, something went wrong!", error);
      });
  };

  return (
    <Fragment>
      <Helmet>
        <title>eksplode! | Account Member</title>
      </Helmet>
      {state && (
        <div className="dashboard">
          <div className="page-title">
            <h2>My Dashboard</h2>
          </div>
          <div className="welcome-msg">
            <h3>
              <small>Hello, </small>
              {`${state.user.first_name} ${state.user.last_name}`}
            </h3>
            <p>
              From your My Account Dashboard you have the ability to view a
              snapshot of your recent account activity and update your account
              information.
            </p>
          </div>
          <div className="box-account box-info">
            <div className="box-head">
              <h2>Account Information</h2>
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="box">
                  <div className="box-title">
                    <h3>Contact Information</h3>
                  </div>
                  <div className="box-content">
                    {pathname.includes("customer") && <h6>{state.phone}</h6>}
                    <h3>{state.user.email}</h3>
                    <div className="box-title">
                      <h3>Download your eksplode! QR for online purchases </h3>
                    </div>
                    <br />
                    <div
                      style={{
                        backgroundColor: "white",
                        display: "flex",
                        padding: "10px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      id="QR"
                    >
                      <QRCode
                        value={user ? user.user._id : null}
                        size={258}
                      ></QRCode>
                    </div>
                    <button
                      className="btn btn-solid float-left"
                      onClick={() => onImageDownload()}
                    >
                      Download Qr
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="box">
                  <div className="box-title">
                    <h3>eksplode! Code</h3>
                  </div>
                  <div className="box-content">
                    <h3>{state.user.eksplode_code}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default AccountMember;
